<script setup>
import NextButton from 'dashboard/components-next/button/Button.vue';
import DateTimePicker from 'components/ui/DateTimePicker.vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  scheduledDate: { type: [Date, String, null], default: null },
});

// Emits
const emit = defineEmits([
  'update:modelValue',
  'schedule',
  'update:scheduledDate',
]);

const handleDateChange = val => {
  emit('update:scheduledDate', val);
};

const closeModal = () => {
  emit('update:modelValue', false);
};

const handleSchedule = () => {
  if (!props.scheduledDate) return;
  emit('schedule');
};
</script>

<template>
  <transition name="modal-fade">
    <div
      v-if="modelValue"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm transition-all"
      @click.self="closeModal"
    >
      <div
        class="bg-white dark:bg-slate-900 p-6 rounded-xl shadow-2xl flex flex-col gap-4 min-w-[300px]"
      >
        <h3 class="text-lg font-medium text-slate-800 dark:text-slate-100">
          {{ $t('CONVERSATION.REPLYBOX.SEND_LATER') }}
        </h3>

        <DateTimePicker
          :value="scheduledDate"
          placeholder="Выберите дату"
          confirm-text="ОК"
          @change="handleDateChange"
        />

        <div class="flex gap-2 mt-2 w-full">
          <NextButton
            label="Отмена"
            hollow
            sm
            class="w-1/2 justify-center"
            @click="closeModal"
          />
          <NextButton
            label="Подтвердить"
            sm
            color="blue"
            class="w-1/2 justify-center"
            :disabled="!scheduledDate"
            @click="handleSchedule"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
